import React from 'react'
import { LinkButton } from './Basics'

export const NotFound: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-10 px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800">404</h1>
        <p className="text-sm text-gray-600 mt-4 mb-10">
          申し訳ございません。
          <br />
          お探しのページが見つかりません。
          <br />
          ページが移動または削除されたか、URLの入力間違いの可能性があります。
          <br />
        </p>
        <LinkButton
          href="/features/qa/mild_cognitive_impairment/consultations/list"
          className="w-11/12 mx-auto focus:outline-none focus:ring focus:border-blue-300  bg-link-color hover:bg-link-color"
        >
          相談一覧画面へ
        </LinkButton>
      </div>
    </div>
  )
}

export default NotFound
